import { Application, Container } from "pixi.js";

export interface PixiSurface {
  app: Application;
  world: Container;
  bubbleLayer: HTMLElement;
  destroy: () => void;
}

export async function createPixiSurface(parent: HTMLElement): Promise<PixiSurface> {
  parent.classList.add("world-mount");
  const app = new Application();
  await app.init({
    background: "#0d1027",
    antialias: true,
    autoDensity: true,
    resolution: Math.min(window.devicePixelRatio || 1, 2),
    resizeTo: parent,
  });
  parent.appendChild(app.canvas);
  app.canvas.style.display = "block";

  const world = new Container();
  world.label = "world";
  app.stage.addChild(world);

  const bubbleLayer = document.createElement("div");
  bubbleLayer.className = "bubble-layer";
  parent.appendChild(bubbleLayer);

  return {
    app,
    world,
    bubbleLayer,
    destroy() {
      bubbleLayer.remove();
      app.destroy(true, { children: true, texture: true });
    },
  };
}
